import { Component, OnInit ,AfterViewInit} from '@angular/core';
import { ServerService } from '../server.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit,AfterViewInit {

  constructor(private server:ServerService) { }
  
  currentTab="mobile";
  currentTitle="Mobile App Dev";
  currentDescription="Mobile Application Development starts with basic introduction to programming all the way up to developing the entire android and iOS applications.";

  bundleData:bundleData[]=[
    new bundleData(1,'Mobile App Dev','Mobile Application Development starts with basic introduction to programming all the way up to developing the entire android and iOS applications.'),
    new bundleData(2,'Full Stack Front-end Dev','Front-End Development starts with basic introduction to programming all the way up to developing the entire front-end of a web-app and website along with additional frameworks.'),
    new bundleData(3,'Full Stack Back-end Dev','Back-End Development starts with basic introduction to programming all the way up to understanding OOPS, DBMS & developing the entire back-end of a web-app and website along with additional frameworks.'),
    new bundleData(4,'Full Stack Dev','Full Stack Development starts with basic introduction to programming all the way up to entire Front-End & Back-End of a web-app and website.'),
    new bundleData(5,'Full Stack Design','Full Stack Design starts with basic introduction to design all the way up to in-depth UX and UI of a web/mobile app and website.'),
    new bundleData(6,'Full Stack Design And Dev','Full Stack Design & Development starts with basic introduction to design and development all the way up to UX, UI, entire Front-End & Back-End of a web-app/mobile app and website.')
  ];

  ngOnInit(): void {
  }

  updateData(id:number){
    this.currentTitle=this.bundleData[id].title;
    this.currentDescription=this.bundleData[id].description;
  }

  print(){
    console.log("read value");
  }

  ngAfterViewInit(): void{
    window.addEventListener('scroll',()=>{
      var scroll= window.pageYOffset;
      var elementy=document.querySelectorAll('.translateY');
      for(var i=0;i<elementy.length;i++){
        var speed=Number(document.getElementById(elementy[i].id).dataset.speed);
        var opacity=Number(document.getElementById(elementy[i].id).dataset.opacity);
        document.getElementById(elementy[i].id).style.transform='translateY('+(scroll*speed)+'px)';
        document.getElementById(elementy[i].id).style.opacity=""+(1-(scroll/1000)*opacity);
      }
      var elementx=document.querySelectorAll('.translateX');
      for(var i=0;i<elementx.length;i++){
        var speed=Number(document.getElementById(elementx[i].id).dataset.speed);
        document.getElementById(elementx[i].id).style.transform='translateX('+(scroll*speed)+'px)';
      }
      var elemento=document.querySelectorAll('.translateO');
      for(var i=0;i<elemento.length;i++){
        var opacity=Number(document.getElementById(elemento[i].id).dataset.opacity);
        document.getElementById(elemento[i].id).style.opacity=""+(1-(scroll/1000)*opacity);
      }
    });
    var data=document.querySelectorAll('.logotext');
    for(var i=0;i<data.length;i++)
    {
      //@ts-ignore
      console.log(data[i].getTotalLength());
    }
  }


  toggletab(val:string){
    this.currentTab=val;
    switch(val){
      case 'mobile':
        this.updateData(0);
        break;
      case 'backend':
        this.updateData(2);
        break;
      case 'frontend':
        this.updateData(1);
        break;
      case 'fsdev':
        this.updateData(3);
        break;
      case 'dedev':
        this.updateData(5);
        break;
      case 'design':
        this.updateData(4);
        break;
    }
  }

   
  email:string;
  firstname:string;
  lastname:string;
  phno:string;
  comment:string="";
  fnvalid:boolean=true;
  lnvalid:boolean=true;
  pvalid:boolean=true;
  evalid:boolean=true;
  fnerrormsg='This field should not be blank';
  lnerrormsg='This field should not be blank';
  eerrormsg='This field should not be blank';
  perrormsg='This field should not be blank';
  modalTitle='Book A Demo';
  btnTxt="Book Now";
  modelId=0;
  model=[{"modelTitle":'Book A Demo',"btnTxt":'Book Now'},{"modelTitle":'Register',"btnTxt":'Register Now'}];

  resolver(){
    if(this.modelId==0){
      this.bookDemo();
    }
    else{
      this.register();
    }
  }

  bookDemo(){
    if(this.fnvalid&&this.lnvalid&&this.pvalid&&this.evalid)
    {
      var valj={
        'firstname': this.firstname,
        'lastname': this.lastname,
        'email': this.email,
        'phone_number': this.phno,
        'message': this.comment
      }
      this.server.book(JSON.stringify(valj));
    }
  }
  register(){
    if(this.fnvalid&&this.lnvalid&&this.pvalid&&this.evalid)
    {
      var valj={
        'firstname': this.firstname,
        'lastname': this.lastname,
        'email': this.email,
        'phone_number': this.phno,
        'cource':this.currentTitle,
        'message': this.comment
      }
      this.server.register(JSON.stringify(valj));
    }
  }

  goToUrl(link:string){
    //window.open(link,'_blank');
  }


  validatefname(){
    if(this.firstname==undefined||this.firstname==null||this.firstname=="")
    {
      this.fnvalid=false;
      this.fnerrormsg='This field should not be blank';
      console.log('fname blank');
    }
    else if(/^[A-Za-z]*$/.test(this.firstname)){
      this.fnvalid=true;
      console.log('valid');
    }
    else{
      this.fnvalid=false;
      this.fnerrormsg='please give a valid value';
      console.log('fname invalid');
    }
  }

  toggler(value:number){
    if(this.modelId!=value)
    {
      this.modelId=(this.modelId==1?0:1);
    }
  }

  validatelname(){
    if(this.lastname==undefined||this.lastname==null||this.lastname=="")
    {
      this.lnvalid=false;
      this.lnerrormsg='This field should not be blank';
    }
    else if(/^[A-Za-z]/.test(this.lastname)){
      this.lnvalid=true;
    }
    else{
      this.lnvalid=false;
      this.lnerrormsg='please give a valid value';
    }
  }

  validateemail(){
    if(this.email==undefined||this.email==null||this.email=="")
    {
      this.evalid=false;
      this.eerrormsg='This field should not be blank';
    }
    else if(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.email)){
      this.evalid=true;
    }
    else{
      this.evalid=false;
      this.eerrormsg='please give a valid value';
    }
  }

  validatefphone(){
    if(this.phno==undefined||this.phno==null||this.phno=="")
    {
      this.pvalid=false;
      this.perrormsg='This field should not be blank';
    }
    else if(/[0-9]{10}$/.test(this.phno)){
      this.pvalid=true;
    }
    else{
      this.pvalid=false;
      this.perrormsg='please give a valid value';
    }
  }
  
  reset(){
    this.email="";
    this.firstname="";
    this.lastname="";
    this.phno="";
    this.comment="";
    this.fnvalid=true;
    this.lnvalid=true;
    this.pvalid=true;
    this.evalid=true;
    this.fnerrormsg='This field should not be blank';
    this.lnerrormsg='This field should not be blank';
    this.eerrormsg='This field should not be blank';
    this.perrormsg='This field should not be blank';
    }
}

class bundleData{
  id:number;
  title:string;
  description:string;
  constructor(i:number,t:string,d:string){
    this.id=i;
    this.title=t;
    this.description=d;
  }
}